import { Icon, spacing } from '@scality/core-ui';
import { Button } from '@scality/core-ui/dist/next';
import type { ComponentProps } from 'react';
import styled from 'styled-components';

type IconName = ComponentProps<typeof Icon>['name'];

export type WidgetActionButtonProps = {
  icon: IconName;
  /** Accessible name; it names the widget, a screen reader meeting several in a row. */
  label: string;
  /** Hover text — the bare verb, the pointer having said which widget. */
  tooltip: string;
  onClick: () => void;
};

export const WidgetActionButton = ({ icon, label, tooltip, onClick }: WidgetActionButtonProps) => (
  <Button
    icon={<Icon name={icon} />}
    size="inline"
    variant="outline"
    tooltip={{ overlay: tooltip }}
    aria-label={label}
    onClick={onClick}
  />
);

/** Styled rather than a `Box`: the widget holding the strip has to address it as a selector. */
export const WidgetActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.r4};
  flex: none;
`;

/** Applied by the widget's own container: the strip cannot see the card it sits in. */
export const revealActionsOnHover = `
  ${WidgetActions} {
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  &:hover ${WidgetActions},
  ${WidgetActions}:focus-within {
    opacity: 1;
  }
`;
